import {UserRepository} from '../repository/UserRepository';
import {UpdateUserRequest, DashboardUser} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class UpdateUserUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (userData: UpdateUserRequest): Promise<DashboardUser> {
    // Validate required fields
    if (!userData.id || userData.id < 1) {
      throw new AppError('معرف المستخدم صحيح مطلوب', ErrorType.VALIDATION);
    }

    // Validate email format if provided
    if (userData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(userData.email)) {
        throw new AppError('تنسيق البريد الإلكتروني غير صحيح', ErrorType.VALIDATION);
      }
    }

    // Validate username format if provided
    if (userData.username) {
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(userData.username)) {
        throw new AppError('اسم المستخدم يمكن أن يحتوي على أحرف وأرقام وشرطات سفلية فقط', ErrorType.VALIDATION);
      }
    }

    // Check if at least one field is provided for update
    const hasUpdateFields = userData.username || userData.email ||
                           userData.fullName || userData.roleId || userData.status;

    if (!hasUpdateFields) {
      throw new AppError('يجب توفير حقل واحد على الأقل للتحديث', ErrorType.VALIDATION);
    }

    try {
      // Update the user
      const updatedUser = await this.userRepository.updateUser(userData);

      return updatedUser;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
